import { useQuery } from '@tanstack/react-query';
import apiClient from '../lib/api-client';

export const useNotifications = () => {
  return useQuery({
    queryKey: ['notifications'],
    queryFn: async () => {
      const response = await apiClient.get('/notifications');
      return response.data;
    },
  });
};